import { PORTFOLIO_FIELD_ORDER, PORTFOLIO_FIELD_LABELS, POST_FIELD_ORDER, POST_FIELD_LABELS } from '../../constants/portfolioFields.ts'

export const formatPortfolioValue = (key: string, value: unknown): string => {
  if (value == null || value === '') return ''
  if (key === 'image_uploaded') return value ? 'Lista' : ''
  if (key === 'content') return ''
  if (key === 'type') {
    const s = String(value)
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  if (key === 'price' && typeof value === 'number') return value.toLocaleString('es-AR')
  if ((key === 'start_date' || key === 'end_date') && typeof value === 'string') {
    try {
      const d = new Date(value)
      return d.toLocaleDateString('es-AR', { day: 'numeric', month: 'short', year: 'numeric' })
    } catch {
      return String(value)
    }
  }
  if (key === 'currency_type') {
    const map: Record<string, string> = { ARS: 'Pesos', USD: 'Dólares', EUR: 'Euros' }
    return map[String(value)] || String(value)
  }
  return String(value)
}

export const parsePortfolioProgress = (llmRawResponse?: string) => {
  if (!llmRawResponse) return null
  try {
    const parsed = JSON.parse(llmRawResponse)
    const missingFields: string[] = parsed.missingFields || []
    const collectedData: Record<string, unknown> = parsed.collectedData || {}
    const intent = collectedData?.intent

    if (intent === 'create_post') {
      const items: { key: string; label: string; done: boolean; value?: string }[] = []
      for (const key of POST_FIELD_ORDER) {
        const hasValue =
          key === 'content'
            ? collectedData[key] != null && String(collectedData[key]).trim() !== ''
            : collectedData[key] === true
        const valueStr = hasValue ? formatPortfolioValue(key, collectedData[key]) : undefined
        items.push({
          key,
          label: POST_FIELD_LABELS[key] || key,
          done: hasValue,
          value: valueStr
        })
      }
      return { items, imagePreviewUrl: parsed.imagePreviewUrl as string | undefined }
    }

    if (missingFields.length === 0 && Object.keys(collectedData).filter(k => k !== 'intent').length === 0) return null
    const items: { key: string; label: string; done: boolean; value?: string }[] = []
    for (const key of PORTFOLIO_FIELD_ORDER) {
      const hasValue = collectedData[key] != null && collectedData[key] !== ''
      const isMissing = missingFields.includes(key)
      if (hasValue || isMissing) {
        const valueStr = hasValue ? formatPortfolioValue(key, collectedData[key]) : undefined
        items.push({
          key,
          label: PORTFOLIO_FIELD_LABELS[key] || key,
          done: hasValue,
          value: valueStr
        })
      }
    }
    if (items.length === 0) return null
    return { items, imagePreviewUrl: parsed.imagePreviewUrl as string | undefined }
  } catch {
    return null
  }
}
